module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_14-d65ae66b7eb32a091436702884a862b8.jpg";